<template>
  <ReportLayoutModerno
    v-if="prefecture"
    id="genericReport"
    :prefecture="prefecture"
    :period="month + '/' + year"
  >
    <template v-slot:icon>mdi-account-hard-hat</template>
    <template v-slot:title>TCE - LOCADOR / PRESTADOR</template>
    <template v-slot:sub-header>
      <h3 class="text-sm font-bold text-slate-600">
        CÓDIGO: <span class="text-orange-600 uppercase">{{ cod }}</span>
      </h3>
    </template>
    
    <div class="overflow-x-auto">
      <table
      class="table"
      style="
        border-collapse: collapse;
        border: 1px solid rgb(214, 214, 214);
        border-top: 0;
        text-align: center;
        width: 100%;
        font-size: 12px;
      "
    >
      <thead>
        <tr style="border: 1px solid rgb(214, 214, 214); text-align: center">
          <th
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 3px;
              text-align: center;
              background: gray;
              color: #fff;
            "
          >
            Código da Unidade Gestora
          </th>
          <th
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 3px;
              text-align: center;
              background: gray;
              color: #fff;
            "
          >
            Cpf/Cnpj do Proprietário
          </th>
          <th
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 3px;
              text-align: center;
              background: gray;
              color: #fff;
            "
          >
            Nome do Proprietário
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(value, index) in data" :key="index">
          <td
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 8px;
              text-align: center;
            "
          >
            {{ value.codUnidadeGestora }}
          </td>
          <td
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 8px;
              text-align: center;
            "
          >
            {{ value.cpfcnpj }}
          </td>
          <td
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 8px;
              text-align: center;
            "
          >
            {{ value.nome }}
          </td>
        </tr>
      </tbody>
      </table>
    </div>
  </ReportLayoutModerno>
</template>

<script>
import helpers from "@/mixins/helpers";
import ReportLayoutModerno from "@/components/ReportLayoutModerno.vue";
export default {
  components: {
    ReportLayoutModerno,
  },
  props: ["data", "cod", "month", "year", "prefecture"],
  mixins: [helpers],
  mounted: {},
  methods: {
    initialize() {
      this.helpers;
    },
  },
};
</script>

<style scoped>
table {
  border-collapse: collapse;
  border: 1px solid rgb(17, 17, 17);
}
</style>
